import { User } from "oidc-react";
import { GroupServiceGetManyResponse, GroupServiceGetResponse } from "../services/api";
import { UserRole } from "../store/auth";
import { GroupStatus } from "./types";
import { getUserFullName } from "./auth";

export function hasOpenRequest(group: GroupServiceGetResponse | null): boolean {
  return group!.requestStatus !== GroupStatus.NO_REQUESTS;
}

export function isGroupCompleted(group: GroupServiceGetResponse): boolean {
  return [
    GroupStatus.TIER2_DECLINED,
    GroupStatus.RERATE_COMPLETED,
    GroupStatus.TIER2_COMPLETED,
    GroupStatus.TIER2_APPROVED,
  ].includes(group.requestStatus as GroupStatus);
}

export function canMakeRequests(group: GroupServiceGetResponse, role?: UserRole | null) {
  return ![
    GroupStatus.HIGH_RISK,
    GroupStatus.HIGH_RISK_REQUESTED,
    ...role !== UserRole.ACTUARY ? [
      GroupStatus.TIER2_REQUESTED,
      GroupStatus.RERATE_REQUESTED,
    ] : [],
    ].includes(group.requestStatus as GroupStatus);
}

export function isGroupHighRisk(group: GroupServiceGetResponse) {
  return group.requestStatus?.toUpperCase().startsWith(GroupStatus.HIGH_RISK_ALL.toUpperCase());
}

export function canGroupBeLocked(group: GroupServiceGetResponse) {
  return ![
    GroupStatus.RERATE_COMPLETED,
    GroupStatus.TIER2_COMPLETED,
  ].includes(group.requestStatus as GroupStatus);
}

export function isReliefAvailableForGroup(group: GroupServiceGetResponse) {
  return !group.policyDetailModel?.optionsShutoff && group.policyDetailModel?.override === 0;
}

export function groupIsAssignedToCurrentUser(group: GroupServiceGetManyResponse, user: User | null | undefined) {
    if (!user?.profile?.email) return false;
    return group.assignedTo === getUserFullName(user);
  }